import { Header } from '@/components/layout/Header';
import { Footer } from '@/components/layout/Footer';
import { mockBlogPosts } from '@/data/mockData';
import { Card } from '@/components/ui/card';
import { Link } from 'react-router-dom';
import { Calendar, User } from 'lucide-react';
import { format } from 'date-fns';
import { fr } from 'date-fns/locale';

const categoryLabels = {
  'conseils-cv': 'CV & Lettres',
  'preparation-entretiens': 'Entretiens',
  'developpement-competences': 'Compétences',
  'portraits-talents': 'Portraits',
  'innovation-tech': 'Innovation & Tech'
};

const categoryColors = {
  'conseils-cv': 'bg-primary',
  'preparation-entretiens': 'bg-secondary',
  'developpement-competences': 'bg-success',
  'portraits-talents': 'bg-accent',
  'innovation-tech': 'bg-cyan-500'
};

export default function Blog() {
  // Sort posts by date (most recent first)
  const sortedPosts = [...mockBlogPosts].sort((a, b) => 
    b.publishedAt.getTime() - a.publishedAt.getTime()
  );

  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main className="container mx-auto px-4 py-8">
        <div className="mb-12">
          <h1 className="text-3xl md:text-4xl font-poppins font-bold text-foreground mb-4">
            Blog & Conseils
          </h1>
          <p className="text-lg text-muted-foreground font-inter max-w-2xl">
            Des conseils pratiques et des histoires inspirantes pour booster votre carrière
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {sortedPosts.map((post) => (
            <Card key={post.id} className="group bg-card hover-lift border border-border hover:border-primary transition-all overflow-hidden">
              {/* Cover Image */}
              <div className="relative h-56 bg-muted overflow-hidden">
                <div className="absolute inset-0 bg-gradient-to-br from-primary-light to-muted"></div>
                
                {/* Category Badge */}
                <div className={`absolute top-4 left-4 ${categoryColors[post.category]} text-white px-3 py-1 rounded-md text-xs font-semibold`}>
                  {categoryLabels[post.category]}
                </div>
                
                {/* Large Letter */}
                <div className="absolute inset-0 flex items-center justify-center">
                  <span className="text-9xl font-bold text-muted-foreground/10">
                    {post.title.charAt(0)}
                  </span>
                </div>
              </div>
              
              <Link to={`/blog/${post.slug}`} className="block p-6">
                <h3 className="font-bold text-xl text-foreground mb-3 line-clamp-2 group-hover:text-primary transition-colors">
                  {post.title}
                </h3>
                
                <p className="text-muted-foreground font-inter text-sm mb-4 line-clamp-3 leading-relaxed">
                  {post.excerpt}
                </p>
                
                <div className="flex items-center justify-between text-sm text-muted-foreground">
                  <div className="flex items-center gap-2">
                    <User className="h-4 w-4" />
                    <span className="font-inter">{post.author}</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <Calendar className="h-4 w-4" />
                    <span className="font-inter">
                      {format(post.publishedAt, 'dd MMM yyyy', { locale: fr })}
                    </span>
                  </div>
                </div>
              </Link>
            </Card>
          ))}
        </div>
      </main>
      <Footer />
    </div>
  );
}